import { useCallback } from 'react';
import {
  composeValidations,
  pathAvailableValidation,
  useValidation,
  pathValidation,
} from './common.js';

function createReactComponentFolderValidation(projectFolder: string) {
  return composeValidations([
    [
      pathAvailableValidation(projectFolder),
      'The script folder must be unique, please choose a name that has not been used yet in your application.',
    ],
    [
      pathValidation,
      'The script folder must be a valid path ([a-z0-9-/]+) and must not start with a dot.',
    ],
  ]);
}

export const useReactComponentFolderValidation = (projectFolder: string) => {
  const validation = useValidation(
    createReactComponentFolderValidation(projectFolder)
  );

  return useCallback(validation, [validation, projectFolder]);
};

export const useReactComponentNameValidation = () => {
  const validation = useValidation(
    composeValidations([
      [
        (name: string) => name.length <= 30,
        'Enter a name that is shorter than 30 characters.',
      ],
    ])
  );

  return useCallback(validation, [validation]);
};
